import { RouterModule, Routes } from '@angular/router';
import { AuthErrorComponent } from './core/components/auth-error/auth-error.component';
import { AuthGuard } from './core/guards/auth.guard';
import { EditUserGuard } from './core/guards/edit-user.guard';

const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/home-page/home-page.component').then(
        (m) => m.HomePageComponent
      ),
    canActivate: [AuthGuard],
    title: $localize`R360 - Home` as string
  },
  {
    path: 'account',
    loadChildren: () =>
      import('./features/account-page/account-page.module').then(
        (m) => m.AccountPageModule
      ),
    canActivate: [AuthGuard],
    title: $localize`R360 - Account` as string
  },
  {
    path: 'alerts',
    loadChildren: () =>
      import('./features/alerts-page/alerts-page.module').then(
        (m) => m.AlertsPageModule
      ),
    canActivate: [AuthGuard],
    title: $localize`R360 - Alerts` as string
  },
  {
    path: 'comparisons',
    loadChildren: () =>
      import('./features/comparisons-page/comparisons-page.module').then(
        (m) => m.ComparisonsPageModule
      ),
    canActivate: [AuthGuard],
    title: $localize`R360 - Comparisons` as string
  },
  {
    path: 'cost',
    loadComponent: () =>
      import(
        './features/cost-avoidance-page/cost-avoidance-page.component'
      ).then((m) => m.CostAvoidancePageComponent),
    canActivate: [AuthGuard],
    title: $localize`R360 - Cost Avoidance` as string
  },
  {
    path: 'company',
    loadChildren: () =>
      import(
        './features/company-management-page/company-management-page.module'
      ).then((m) => m.CompanyManagementPageModule),
    title: $localize`R360 - Company Management` as string
  },
  {
    path: 'sensor-driven-applications',
    loadComponent: () =>
      import(
        './features/sensor-driven-applications-page/sensor-driven-applications-page.component'
      ).then((m) => m.SensorDrivenApplicationsPageComponent),
    canActivate: [AuthGuard],
    title: $localize`R360 - Sensor Driven Apps` as string
  },
  {
    path: 'dashboard/:id',
    loadComponent: () =>
      import('./features/summary-dashboard/summary-dashboard.component').then(
        (m) => m.SummaryDashboardComponent
      ),
    canActivate: [AuthGuard]
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./features/summary-dashboard/summary-dashboard.component').then(
        (m) => m.SummaryDashboardComponent
      ),
    canActivate: [AuthGuard]
  },
  {
    path: 'assets',
    loadChildren: () =>
      import('./features/assets-page/assets-page.module').then(
        (m) => m.AssetsPageModule
      ),
    canActivate: [AuthGuard],
    title: $localize`R360 - Assets` as string
  },
  {
    path: 'recommendations',
    loadChildren: () =>
      import(
        './features/recommendations-page/recommendations-page.module'
      ).then((m) => m.RecommendationsPageModule),
    canActivate: [AuthGuard],
    title: $localize`R360 - Recommendations` as string
  },
  {
    path: 'devices',
    loadChildren: () =>
      import('./features/devices-page/devices-page.module').then(
        (m) => m.DevicesPageModule
      ),
    canActivate: [AuthGuard],
    title: $localize`R360 - Devices` as string
  },
  {
    path: 'reports',
    loadChildren: () =>
      import('./features/reporting-page/reporting.module').then(
        (m) => m.ReportingModule
      ),
    canActivate: [AuthGuard],
    title: $localize`R360 - Reporting` as string
  },
  {
    path: 'hierarchy',
    loadChildren: () =>
      import('./features/hierarchy-page/hierarchy-page.module').then(
        (m) => m.HierarchyPageModule
      ),
    canActivate: [AuthGuard],
    title: $localize`R360 - Hierarchy` as string
  },
  {
    path: 'knowledgebase',
    redirectTo: 'https://knowledge.iiot.advancedtech.com/'
  },
  {
    path: 'contacts',
    loadChildren: () =>
      import('./features/contact-page/contact-page.module').then(
        (m) => m.ContactPageModule
      ),
    canActivate: [AuthGuard],
    title: $localize`R360 - Contacts` as string
  },
  {
    path: 'user/:id',
    loadChildren: () =>
      import('./features/user-info/user-info-page.module').then(
        (m) => m.UserInfoPageModule
      ),
    canActivate: [AuthGuard, EditUserGuard],
    title: $localize`R360 - User Info` as string
  },
  {
    path: 'auth_error',
    component: AuthErrorComponent
  },
  { path: '**', redirectTo: '' }
];
export const appRoutes = RouterModule.forRoot(routes);
